/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CampaignNumberGraphData,
  CategorizedLeadData,
  DateRangeInput,
  DateRangeLeadsGranular,
  ErpFilter,
  ErrorResponse,
} from '../models/index';
import {
    CampaignNumberGraphDataFromJSON,
    CampaignNumberGraphDataToJSON,
    CategorizedLeadDataFromJSON,
    CategorizedLeadDataToJSON,
    DateRangeInputFromJSON,
    DateRangeInputToJSON,
    DateRangeLeadsGranularFromJSON,
    DateRangeLeadsGranularToJSON,
    ErpFilterFromJSON,
    ErpFilterToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/index';

export interface CategoryOverviewRequest {
    projectId: string;
    dateRangeInput?: DateRangeInput;
}

export interface DateOverviewRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface FiltersRequest {
    projectId: string;
}

export interface VerifiedLeadsInTimeByCampaignRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface VerifiedLeadsInTimeByCategoriesRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

/**
 * 
 */
export class LeadCalculationApi extends runtime.BaseAPI {

    /**
     * Returns data file uri.
     */
    async categoryOverviewRaw(requestParameters: CategoryOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CategorizedLeadData>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling categoryOverview().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/project/{projectId}/lead/categoryOverview`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DateRangeInputToJSON(requestParameters['dateRangeInput']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CategorizedLeadDataFromJSON(jsonValue));
    }

    /**
     * Returns data file uri.
     */
    async categoryOverview(requestParameters: CategoryOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CategorizedLeadData> {
        const response = await this.categoryOverviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns data file uri.
     */
    async dateOverviewRaw(requestParameters: DateOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DateRangeLeadsGranular>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling dateOverview().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/project/{projectId}/lead/dateOverview`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DateRangeLeadsGranularFromJSON(jsonValue));
    }

    /**
     * Returns data file uri.
     */
    async dateOverview(requestParameters: DateOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DateRangeLeadsGranular> {
        const response = await this.dateOverviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns filters by project.
     */
    async filtersRaw(requestParameters: FiltersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Array<string>>>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling filters().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/project/{projectId}/lead/filters`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns filters by project.
     */
    async filters(requestParameters: FiltersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Array<string>>> {
        const response = await this.filtersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns data file uri.
     */
    async verifiedLeadsInTimeByCampaignRaw(requestParameters: VerifiedLeadsInTimeByCampaignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CampaignNumberGraphData>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling verifiedLeadsInTimeByCampaign().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/project/{projectId}/lead/verified-leads-in-time-by-campaign`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CampaignNumberGraphDataFromJSON(jsonValue));
    }

    /**
     * Returns data file uri.
     */
    async verifiedLeadsInTimeByCampaign(requestParameters: VerifiedLeadsInTimeByCampaignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CampaignNumberGraphData> {
        const response = await this.verifiedLeadsInTimeByCampaignRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns data file uri.
     */
    async verifiedLeadsInTimeByCategoriesRaw(requestParameters: VerifiedLeadsInTimeByCategoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CampaignNumberGraphData>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling verifiedLeadsInTimeByCategories().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/project/{projectId}/lead/verified-leads-in-time-by-categories`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CampaignNumberGraphDataFromJSON(jsonValue));
    }

    /**
     * Returns data file uri.
     */
    async verifiedLeadsInTimeByCategories(requestParameters: VerifiedLeadsInTimeByCategoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CampaignNumberGraphData> {
        const response = await this.verifiedLeadsInTimeByCategoriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
